<template>
  <footer class="layout-footer">
    <div class="container">
      <div class="breadcrumbs">
        <slot name="breadcrumbs"></slot>
      </div>
      <div class="content row-between">
        <div class="menu">
          <div class="menu-columns">
            <slot name="menu"></slot>
          </div>
          <div class="left-botttom">
            <slot name="left-bottom"></slot>
          </div>
        </div>
        <div class="right">
          <div class="contacts">
            <slot name="contact"></slot>
          </div>
          <transition name="slide-fade" mode="out-in">
          <div v-if="!send" class="subscribe-block" key="subscribe-off">
                <input title="введите ваш email" type="email" v-model="mail" placeholder="Подпишитесь на рассылку" />
                <button @click="sendSubscribe()"><icon-arrow-right></icon-arrow-right></button>
          </div>
          <div v-else class="subscribe-block" key="subscribe-on">
            <input type="email" disabled placeholder="Вы подписаны" />
          </div>
          </transition>
          <div class="payments">
            <slot name="payments"></slot>
          </div>
          <div class="right-botttom">
            <slot name="right-bottom"></slot>
          </div>
          <div class="left-botttom-mobile">
            <slot name="left-bottom"></slot>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data(){
    return {
      mail: "",
      send: false
    }
  },
  methods: {
    sendSubscribe( text ) {
      if( this.mail==="" ){
        //this.$notify({group: 'error-form', title: 'error', text: this.$store.state.langs.NOTIFICATION_ERROR_FIELD, type: 'error'});
        return false;
      }
      this.$axios({
        url: '/ajax/?subscribe=Y',
        method: 'post',
        params: {
          email: this.mail
        }
      }).then(response => {
        if (response.status == 200 && response.data.success) {
          //console.log( "response", response );
          if (typeof (ym) === "function") {
            let yaCounterId = this.$store.state.langs.YACOUNTER;
            ym(yaCounterId, 'reachGoal', 'subscribe_sent');

            let yaCounterId2 = this.$store.state.langs.YACOUNTER2;
            ym(yaCounterId2, 'reachGoal', 'subscription');
            ym(yaCounterId2, 'reachGoal', 'all_forms');
          }
          this.send = true;
        }else{
          console.log('Error feedback success: false')
        }
      }).catch(e => {
        console.log('Error: ' + e)
      })
      //this.loading = false;
    },
  },
  components: {
    'icon-arrow-right': () => import('@/components/icon/icon-arrow-right')
  },
  created() {
    var cookieTime121 = Number(this.$cookie.get('time121'));
    var cookiePagesee = Number(this.$cookie.get('pagesee'));
    let t = 0;
    let p = 0;
    if(!cookieTime121) {
      var seconds_timer_id = setInterval( () => {
        if (t < 122) {
          t = t + 1;
          p = p + 1;
          this.$cookie.set('time121', t);
          this.$cookie.set('pagesee', t);
        } else {
          this.$cookie.set('time121', 300);
          if (typeof (ym) === "function") {
            let yaCounterId = this.$store.state.langs.YACOUNTER;
            ym(yaCounterId, 'reachGoal', '121sec');
          }
          if (p > 1 && typeof (ym) === "function") {
            let yaCounterId = this.$store.state.langs.YACOUNTER;
            ym(yaCounterId, 'reachGoal', '2views_121sec');
          }
          if (p > 3 && typeof (ym) === "function") {
            let yaCounterId = this.$store.state.langs.YACOUNTER;
            ym(yaCounterId, 'reachGoal', '4views_121sec');
          }
          clearInterval(seconds_timer_id);
        }
      }, 1000);
    }else{
      if( cookieTime121<122 ) {
        var seconds_timer_id = setInterval( () => {
          cookieTime121 = cookieTime121 + 1;
          cookiePagesee = cookiePagesee + 1;
          if( cookieTime121 < 122 ){
            this.$cookie.set('time121', cookieTime121 );
            this.$cookie.set('pagesee', cookiePagesee );
          } else {
            this.$cookie.set('time121', 300 );
            if (typeof (ym) === "function") {
              let yaCounterId = this.$store.state.langs.YACOUNTER;
              ym(yaCounterId, 'reachGoal', '121sec');
            }
            if (cookiePagesee > 1 && typeof (ym) === "function") {
              let yaCounterId = this.$store.state.langs.YACOUNTER;
              ym(yaCounterId, 'reachGoal', '2views_121sec');
            }
            if (cookiePagesee > 3 && typeof (ym) === "function") {
              let yaCounterId = this.$store.state.langs.YACOUNTER;
              ym(yaCounterId, 'reachGoal', '4views_121sec');
            }
            clearInterval(seconds_timer_id);
          }
        }, 1000)
      }
    }
  },
  mounted() {},
}
</script>

<style lang="scss" scoped>
.layout-footer {
  background: var(--color);
  color: #fff;
  padding: 1.8em var(--gap);
}
.menu-columns {
  display: grid;
  grid-auto-columns: max-content;
  grid-auto-flow: column;
  gap: 5em;
  margin-top: 3em;
  ul {
    list-style: none;
  }
  & > * {
    & > a {
      display: block;
      font-weight: 600;
      margin-bottom: 1.25em;
    }
    & > * {
      li {
        margin-bottom: 0.3em;
      }
      &.column-2 {
        columns: 2;
        break-inside: avoid;
        column-gap: 5em;
      }
    }
  }
}
.content {
  align-items: stretch;
  & > * {
    display: flex;
    flex-direction: column;
    & > * {
      &:last-child {
        margin-top: auto;
      }
    }
  }
}
.contacts {
  margin-top: 3em;
  & > * {
    margin-bottom: 1.25em;
  }
}

form {
  --size: 50px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: var(--size);
  display: flex;
  width: 300px;
  margin: 2em 0;
  input {
    height: var(--size);
    font-family: inherit;
    font-size: 18px;
    font-weight: 500;
    padding: 0 20px;
    color: #fff;
    flex-grow: 1;
    border: none;
    background: none;
    &::-webkit-input-placeholder {
      color: rgba(255, 255, 255, 1);
    }
    &::-moz-placeholder {
      color: rgba(255, 255, 255, 1);
    }
    &:-moz-placeholder {
      color: rgba(255, 255, 255, 1);
    }
    &:-ms-input-placeholder {
      color: rgba(255, 255, 255, 1);
    }
  }
  button {
    width: var(--size);
    height: var(--size);
    border-radius: 50%;
    background: #fff;
    color: var(--color);
    display: flex;
    align-items: center;
    flex-shrink: 0;
    justify-content: center;
  }
}

.subscribe-block {
  --size: 50px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: var(--size);
  display: flex;
  width: 100%;
  margin: 2em 0;
  input {
    height: var(--size);
    font-family: inherit;
    font-size: 12px;
    font-weight: 500;
    padding: 0 0 0 10px;
    color: #fff;
    flex-grow: 1;
    background: none;
    border: none;
    &::-webkit-input-placeholder {
      color: rgba(255, 255, 255, 1);
    }
    &::-moz-placeholder {
      color: rgba(255, 255, 255, 1);
    }
    &:-moz-placeholder {
      color: rgba(255, 255, 255, 1);
    }
    &:-ms-input-placeholder {
      color: rgba(255, 255, 255, 1);
    }
  }
  button {
    width: var(--size);
    height: var(--size);
    border-radius: 50%;
    background: #fff;
    color: var(--color);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0;
  }
}
.slide-fade-enter-active {
  transition: all .3s ease-out;
}

.slide-fade-leave-active {
  transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
.payments {
  margin-bottom: 3em;
  div {
    margin-bottom: 0.8em;
  }
  img {
    height: 1.5em;
    margin-right: 1em;
  }
}
.left-botttom-mobile {
  display: none;
}
@media screen and (max-width: 920px) {
  .content {
    display: block;
  }
  .left-botttom-mobile {
    display: block;
  }
  .left-botttom {
    display: none;
  }
}
@media screen and (max-width: 767px) {
  .menu-columns {
    gap: 3em;
    overflow: scroll;
    /* display: block; */
  }
}
</style>
